module.exports = __webpack_public_path__ + "img/linkedinLogo.0aef6c06.svg";